(function ($) {
	"use strict";
	
    jQuery(document).ready(function($){
		
		/*Popover*/
		$('[data-toggle="popover"]').popover(
    		{
			html : true,
			trigger: 'focus',
			//trigger :'manual',
			content: function() {
				var content = $(this).attr("data-popover-content");
				return $(content).children(".popover-body").html();
			}
	    });
		
		$('[data-toggle="tooltip"]').tooltip();
		 
		//For mobile menu
		$("ul#navigation").slicknav({
            prependTo: ".mobile-menu-wrapper"
        }); 

		//Main Slider
        $(".home-banner").slick({
            slidesToShow: 1,
			arrows: true,
            dots: false,
            autoplay: true,
            infinite: true,
            draggable: false,
            //touchMove: false,
			fade: true,
			prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left''></i></button>",
		    nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",
        });
		
		//Testimonial
        $(".testimonial").slick({
            slidesToShow: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            infinite: true,
            prevArrow: "<button type='button' class='slick-next'><i class='fas fa-long-arrow-alt-right'></i></button>",
			nextArrow: "<button type='button' class='slick-prev'><i class='fas fa-long-arrow-alt-left'></i></button>",
            mouseDrag: false,
            //touchMove: false,
			animateOut: 'slide',
        });
        
                $(".inner-slider").slick({
            slidesToShow: 1,
			arrows: false,
            dots: false,
            autoplay: true,
            infinite: true,
            draggable: false,
            //touchMove: false,
			fade: true,
			pauseOnHover:false,
        });
		
		//People Say
		$('.peoplesay-slide').slick({
	  	 slidesToShow: 3,	
		  dots: false,
		  arrows: true,
		  infinite: true,
		  //speed: 300,
		  prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left''></i></button>",
		  nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",
		  
		  animateOut: 'slide',
		  responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 1,
				slidesToScroll:1
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
		});
        
        //np9 Reviews
		$('.np9-slider').slick({
	  	 slidesToShow: 1,	
		  dots: false,
		  arrows: false,
            autoplay: true,
          infinite:true,
  autoplaySpeed: 5000,
		  infinite: true,
            fade: true,
		  //speed: 300,
		  prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left''></i></button>",
		  nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",	
		});  
        
        //np9 Reviews
		$('.np9-reviews-slider').slick({
	  	 slidesToShow: 1,	
		  dots: true,
		  arrows: false,
		  infinite: true,
		  //speed: 300,
		  prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left''></i></button>",
		  nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",	
		});
        $('.play-video').on('click', function(ev) {
            $(this).parent().addClass('play');
            $(".play #video")[0].src += "&autoplay=1";
            ev.preventDefault();
       });
		

		//WOW animation
		new WOW().init();
		
		$(".scrollup").on("click", function() {
			$("body,html").stop(false, false).animate({
				scrollTop: 0
			}, 800);
			return false;
		});
		
		$(window).on('scroll',function() {
		  if ($(this).scrollTop() > 0){  
			  $('header.for-sticky').addClass("sticky");
		     } else {
			  $('header.for-sticky').removeClass("sticky");
		   }
		   
		   if ($(this).scrollTop() > 200) {
				$('.scrollup').fadeIn();
			} else {
				$('.scrollup').fadeOut();
			}
		   
		});
      console.log("SSJSJJSJ");
        $(".np8-bannerUpdate-img").slick({
            slidesToShow: 4,
			arrows: false,
            dots: false,
            autoplay: true,
            infinite: true,
            //touchMove: false,
			prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left''></i></button>",
		    nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",
			responsive: [
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 2,
				  }
				},
				{
				  breakpoint: 481,
				  settings: {
					slidesToShow: 1,
				  }
				}
			  ]
		
		});


    });

}(jQuery));	